import _ from 'lodash';
import {textInputInitialize, textInputClearance} from './textInputInitialize';
import {comboBoxInputInitialize, comboBoxInputClearance} from './comboBoxInputInitialize';
import {textAreaInputInitialize, textAreaInputClearance} from './textAreaInputInitialize';
import {booleanInputInitialize, booleanInputClearance} from './booleanInputInitialize';
import {radioGroupInitialize, radioGroupClearance} from './radioGroupInitialize';
import {checkboxGroupInitialize, checkboxGroupClearance} from './checkboxGroupInitialize';
import {datePickerInitialize, datePickerClearance} from './datePickerInitialize';
import {uploadButtonInitialize, uploadButtonClearance} from './uploadButtonInitialize';
import {generateError} from '../validations/errors';
import reporter from '../reporter';

const compTypeToInitializeMethod = {
    'wysiwyg.viewer.components.inputs.TextInput': textInputInitialize,
    'wysiwyg.viewer.components.inputs.ComboBoxInput': comboBoxInputInitialize,
    'wysiwyg.viewer.components.inputs.TextAreaInput': textAreaInputInitialize,
    'wysiwyg.viewer.components.inputs.Checkbox': booleanInputInitialize,
    'wysiwyg.viewer.components.inputs.RadioGroup': radioGroupInitialize,
    'wysiwyg.viewer.components.inputs.CheckboxGroup': checkboxGroupInitialize,
    'wysiwyg.viewer.components.inputs.DatePicker': datePickerInitialize,
    'wysiwyg.viewer.components.inputs.FileUploader': uploadButtonInitialize
};

const compTypeToRemovalMethod = {
    'wysiwyg.viewer.components.inputs.TextInput': textInputClearance,
    'wysiwyg.viewer.components.inputs.ComboBoxInput': comboBoxInputClearance,
    'wysiwyg.viewer.components.inputs.TextAreaInput': textAreaInputClearance,
    'wysiwyg.viewer.components.inputs.Checkbox': booleanInputClearance,
    'wysiwyg.viewer.components.inputs.RadioGroup': radioGroupClearance,
    'wysiwyg.viewer.components.inputs.CheckboxGroup': checkboxGroupClearance,
    'wysiwyg.viewer.components.inputs.DatePicker': datePickerClearance,
    'wysiwyg.viewer.components.inputs.FileUploader': uploadButtonClearance
};

const componentsInitialize = (RMI, contextId, compIdToCompType) => {
    _.forEach(compIdToCompType, (compType, compId) => {
        const initializeMethod = compTypeToInitializeMethod[compType];

        if (initializeMethod) {
            initializeMethod(RMI, contextId, compId);
        }
    });
};

const componentsRemoval = (RMI, contextId, compIdToCompType) => {
    _.forEach(compIdToCompType, (compType, compId) => {
        const removalMethod = compTypeToRemovalMethod[compType];

        if (removalMethod) {
            removalMethod(RMI, contextId, compId);
        }
    });
};

function extendComponentsInitialize(viewerType, initializeMethod) {
    if(compTypeToInitializeMethod[viewerType]){
        reporter.reportSdkError(generateError.error_component_already_exists({component: viewerType}));
        return false;
    }

    compTypeToInitializeMethod[viewerType] = initializeMethod;

    return true;
}

function extendComponentsRemoval(viewerType, removalMethod) {
    if(compTypeToRemovalMethod[viewerType]){
        reporter.reportSdkError(generateError.error_component_already_exists({component: viewerType}));
        return false;
    }

    compTypeToRemovalMethod[viewerType] = removalMethod;

    return true;
}

export default {
    componentsInitialize,
    componentsRemoval,
    extendComponentsInitialize,
    extendComponentsRemoval
};
